import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["size", "shouldFitContainer", "width"];
import React from "react";
import PrimitiveSkeletonBox from "../primitives";
import { jsx as _jsx } from "react/jsx-runtime";
function ButtonSkeleton(_ref) {
  var _ref$size = _ref.size,
    size = _ref$size === void 0 ? "default" : _ref$size,
    _ref$shouldFitContain = _ref.shouldFitContainer,
    shouldFitContainer = _ref$shouldFitContain === void 0 ? false : _ref$shouldFitContain,
    width = _ref.width,
    boxProps = _objectWithoutProperties(_ref, _excluded);
  var height = size === "compact" ? 27.9 : 33.9;
  var calculatedWidth = shouldFitContainer ? "100%" : width;
  return /*#__PURE__*/_jsx(PrimitiveSkeletonBox, _extends({}, boxProps, {
    height: height,
    width: calculatedWidth
  }));
}
export default ButtonSkeleton;